export interface IAssociateRegionToCustomerRequest {
  partnerNumber: string;
  leadNumber: string;
  utilityId: number;
  regionId: number;
}

export class AssociateRegionToCustomerRequest
  implements IAssociateRegionToCustomerRequest {
  partnerNumber: string;
  leadNumber: string;
  utilityId: number;
  regionId: number;
}
